import actions from './actions';
const {
  GET_ORDERS,
  GET_ORDERS_ERR,
  GET_ORDERS_BEGIN,
  GET_CUSTOMERS,
  GET_CUSTOMERS_BEGIN,
  GET_CUSTOMERS_ERR,
  FILTER_ORDER_BEGIN,
  FILTER_ORDER_ERR,
  FILTER_ORDER_SUCCESS,
} = actions;
const initState = {
  orders: [],
  page: 1,
  totalResults: 0,
  limit: 0,
  customers: [],
  loading: false,
  error: null,
  filterOrders: [],
};

/**
 *
 * @todo impure state mutation/explaination
 */
const OrdersReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_ORDERS:
      return {
        ...state,
        loading: false,
        orders: data.results,
        totalResults: data.totalResults,
        limit: data.limit,
        page: data.page,
      };
    case GET_ORDERS_ERR:
      return {
        ...state,
        loading: false,
        error: err,
      };
    case GET_ORDERS_BEGIN:
      return {
        ...state,
        error: null,
        orders: [],
        totalResults: initState.totalResults,
        limit: initState.limit,
        page: initState.page,
        loading: true,
      };
    case GET_CUSTOMERS:
      return {
        ...state,
        loading: false,
        customers: data,
      };
    case GET_CUSTOMERS_ERR:
      return {
        ...state,
        loading: false,
        error: err,
      };
    case GET_CUSTOMERS_BEGIN:
      return {
        ...state,
        error: null,
        customers: [],
        loading: true,
      };
    case FILTER_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
        filterOrders: data,
      };
    case FILTER_ORDER_ERR:
      return {
        ...state,
        loading: false,
        error: err,
      };
    case FILTER_ORDER_BEGIN:
      return {
        ...state,
        error: null,
        filterOrders: [],
        loading: true,
      };
    default:
      return state;
  }
};
export default OrdersReducer;
